import { iCommunicationModuleConfigExt } from "./iCommunicationModuleConfigExt";

const config: iCommunicationModuleConfigExt = {
	paths: {
		language: {
			path: 'literales',
			withAuth: false,
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/literales-api/v2',
					protocol: 'https',
				},
				post: {
					host: 'localhost:9000',
					basepath: 'api',
					protocol: 'http',
				},
			},
		},
		auth: {
			path: 'validate',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'register/v2/webRegister',
					protocol: 'https',
				},
			},
		},
		createUserSSO: {
			path: 'createUserSSO',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'register/v2/webRegister',
					protocol: 'https',
				},
			},
		},
		registerCase: {
			path: 'register',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'register/v2/webRegister',
					protocol: 'https',
				},
			},
		},
		performTask: {
			path: 'performTask',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
					protocol: 'https',
				},
			},
		},
		getTasks: {
			path: 'getTasks',
			withAuth: false,
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
					protocol: 'https',
				},
			},
		},
		getTaskInfo: {
			path: 'getTaskInfo',
			withAuth: false,
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
					protocol: 'https',
				},
			},
		},
		identificationDisclamer: {
			path: '1.0.2',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/disclaimer-versionado/v2/disclaimer',
					protocol: 'https',
				},
			},
		},
		downloadContract: {
			path: 'contractsMYBEId',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'inversiones/v2/basicOperations',
					protocol: 'https',
				},
			},
		},
		createIdentity: {
			path: 'identities/onsite',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestSms: {
			path: 'signatures/request/sms',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestEmail: {
			path: 'signatures/request/email',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		signSms: {
			path: 'signatures/sign/sms',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		signEmail: {
			path: 'signatures/sign/email',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestVideoIDAuthorization: {
			path: 'videoid.request',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestVideoScanAuthorization: {
			path: 'videoscan.request',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		electronicPictureId: {
			path: 'pictureid',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestVideoInfo: {
			path: 'videoid',
			withAuth: false,
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		requestVideoScanInfo: {
			path: 'videoscan',
			withAuth: false,
			verbs: {
				get: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/electronic-id/v2/api',
					protocol: 'https',
				},
			},
		},
		personalDataDisclamer: {
			path: '1.0.2.4',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/disclaimer-versionado/v2/disclaimer',
					protocol: 'https',
				},
			},
		},
		preferPrivacidad: {
			path: '/',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/postActPreferprivacidad',
					protocol: 'https',
				},
			},
		},
		getCountries: {
			path: 'kyc/list/PAISOS',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		getActivities: {
			path: 'kyc/list/ACTIVIOLY',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		saveKycData: {
			path: 'saveKYCData',
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		uploadDocument: {
			path: 'uploadDocument',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
					protocol: 'https',
				},
			},
		},
		loginApp: {
			path: '/',
			withAuth: false,
			verbs: {
				get: {
					host: 'myinvappuat.andbank.com',
					basepath: '',
					protocol: 'https',
				},
			},
		},
		validateUserSIA: {
			path: 'validateUserONB',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/altaCliente/v2',
					protocol: 'https',
				},
			},
		},
		electronicIDScript: {
			path: '',
			withAuth: false,
			verbs: {
				get: {
					host: 'etrust-sandbox.electronicid.eu/js/videoid-3.x/videoid.js',
					protocol: 'https',
				},
			},
		},
		electronicIDScanScript: {
			path: '',
			withAuth: false,
			verbs: {
				get: {
					host: 'etrust-sandbox.electronicid.eu/js/videoid-3.x/videoscan.js',
					protocol: 'https',
				},
			},
		},
		androidApp: {
			path: '/',
			withAuth: false,
			verbs: {
				get: {
					host: 'play.google.com/store/apps/details?id=com.andbank.myandbank',
					basepath: '',
					protocol: 'https',
				},
			},
		},
		iOSApp: {
			path: '/',
			withAuth: false,
			verbs: {
				get: {
					host: 'apps.apple.com/es/app/myandbank/id6444284325',
					basepath: '',
					protocol: 'https',
				},
			},
		},
		deleteCase: {
			path: 'deleteCase',
			withAuth: false,
			verbs: {
				post: {
					host: 'abkt03.azure-api.net',
					basepath: 'uat/canalcliente/appian-web-api/v2/api',
					protocol: 'https',
				},
			},
		},
        validate: {
            path: 'validate',
			withAuth: false,
            verbs: {
                get: {
                    basepath: 'uat/canalcliente/altaCliente/v2',
                },
                post: {
                    basepath: 'uat/canalcliente/altaCliente/v2',
                },
                put: {
                    basepath: 'uat/canalcliente/altaCliente/v2',
                },
            },
        },
	},
	host: 'abkt03.azure-api.net',
	basepath: '',
	protocol: 'https',
	timeout: 0,
};

export { config };